import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService, StorageService } from '../../_services/index';
import { DataService, OptionsserviceService, LoansService, OperationsService } from '../../_services/index';
import { CustomersService } from 'src/app/_services/customers.service';

@Component({
  selector: 'app-applicationsrequests',
  templateUrl: './applicationsrequests.component.html',
  styleUrls: ['./applicationsrequests.component.css']
})
export class ApplicationsrequestsComponent implements OnInit {

  text = 'Previous Requests';
  currentUser: any;
  parentRouteId: any;
  sub: any;
  loan: any;
  creating_contract = false;
  has_workflow = false;
  showPicture = false;
  loading = false;
  public canViewModule = true;
  loans = [];
  resp = {}; 
  start = 0;
  data: any;
  constructor(private dataService: DataService,
    public route: ActivatedRoute,
    public storageService: StorageService,
    public optionsService: OptionsserviceService,
    public loansService: LoansService,
    public operationsService: OperationsService,
    protected customersSrvc: CustomersService,
    public router: Router) {
    this.currentUser = this.storageService.read<any>('currentUser');
  }
  ngOnInit() {
    this.getSummary();
  }
  getSummary() {
    this.sub = this.route.params.subscribe(params => {
      this.parentRouteId = +params['id'];
      this.getLoan();
    });

  }
  getLoan() {
    this.loading = true;
    this.loansService.getLoanContractSimplest(this.currentUser.token, this.parentRouteId)
      .subscribe(data => {
        this.loading = false;
        this.loan = data.loan;
        this.dataService.onRequestLoadingEndFromBackend.emit({loan: this.loan});
        this.load_records();
      });
  }
  openModal(section) {
    this.dataService.onOpenApplicationsModal.emit({ section: section, request_id: this.parentRouteId });
  }
  doingDisbursement(event) {
    event.new_loan = this.loan;
    this.dataService.disbursingRequest.emit(event);
  }
  openOfferLetter(request_id) {
    this.router.navigate(['./applications/offerletter/' + request_id]);
  }
  load_records() {
    this.loading = true;
      this.customersSrvc.getLoansForCustomers(this.loan.people_id, this.start, this.parentRouteId).subscribe(data => {
        this.loading = false;
          this.resp = data;
          this.loans = data.loans;
          this.data = data

          // Publish section
          //this.DataService.onProfileNav.emit({ 'location': 'loans', 'data': data });
      });
  }
  loadMoreRecords(start) {
      this.start = start;
      this.load_records();
  }
}
